import { SET_ERRORS, LOADING_UI, CLEAR_ERRORS } from "../../../constants/types";
import { Nullable } from "../../../types/common";
import { IError } from "../../../redux/actions/errorHandlingAction";

export interface IUserInterfaceState {
  UI: UserInterfaceState;
}

interface UserInterfaceState {
  loading: boolean;
  errors: Nullable<IError>;
}

const initialState: UserInterfaceState = {
  loading: false,
  errors: null,
};

const uiReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_ERRORS:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        loading: false,
        errors: null,
      };
    case LOADING_UI:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};

export default uiReducer;
